<template>
  <BaseSection v-if="getCurrentStep+1>1 && getSection('reason').text">
    <template #title>{{step}}. Change Reason</template>

    <template #content>{{getSection('reason').text}}</template>
  </BaseSection>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/ChangedSections/BaseSection';

  export default {

    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: {BaseSection},

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection']),
    },

  }
</script>

<style lang="scss" scoped></style>
